export default __webpack_public_path__ + "static/media/fake-news.b5a495ff.png";